
export interface Data {
  id: string;
  type: string;
  name?: string;
  total_amount_due?: number;
  total_amount_overdue?: number;
  total_amount_invoiced?: number;
  unpaid_invoices?: number;
  average_sale?: number;
  average_days_to_pay?: number;
  dependence?: number;
  last_activity?: Date;
  contact_name?: string;
  converted_amount_due?: number;
  converted_amount_total?: number;
  due_date?: Date;
  invoice_number?: string;
  issue_date?: Date;
  expected_date?: Date;
  excluded_from_report?: boolean;
  pdf_name?: string;
  created_by?: string;
  saved_on?: Date;
  // report_name?: string;
  next_generate_at?: Date;
  period?: string;
  users?: string;
  time?: string;
  held_for_review?: string;
  status?: string;
}

export enum TABLE_COLUMN {
  TYPE = 'type',
  CONTACT = 'name',
  TOTAL_DUE = 'total_amount_due',
  TOTAL_OVERDUE = 'total_amount_overdue',
  TOTAL_INVOICED = 'total_amount_invoiced',
  INVOICES_DUE = 'unpaid_invoices',
  AVERAGE_SALE = 'average_sale',
  DAYS_TO_PAY = 'average_days_to_pay',
  DEPENDENCE = 'dependence',
  LAST_ACTIVITY = 'last_activity',
  CONTACT_NAME = 'contact_name',
  CONVERTED_AMOUNT_DUE = 'converted_amount_due',
  CONVERTED_AMOUNT_TOTAL = 'converted_amount_total',
  DUE_DATE = 'due_date',
  INVOICE_NUMBER = 'invoice_number',
  ISSUE_DATE = 'issue_date',
  EXPECTED_DATE = 'expected_date',
  PDF_NAME = 'pdf_name',
  CREATED_BY = 'created_by',
  SAVED_ON = 'saved_on',
  REPORT_NAME = 'name',
  NEXT_GENERATE_AT = 'next_generate_at',
  PERIOD = 'period',
  SENDING_TO = 'users',
  TIME = 'time',
  HELD_FOR_REVIEW = 'held_for_review',
  STATUS = 'status'
}

export enum FilterTableActionTypes {
  SET_INITIAL_DATA = 'SET_INITIAL_STATE',
  TOGGLE_FILTER_MENU = 'TOGGLE_FILTER_MENU',
  SET_SORT = 'SET_SORT',
  SUBMIT_FILTERS = 'SUBMIT_FILTERS',
  SET_FILTERS_AND_SORT = 'SET_FILTERS_AND_SORT',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  CLEAR_ACTIVE_COLUMN_FILTER = 'CLEAR_ACTIVE_COLUMN_FILTER',
  SUBMIT_EXPECTED_DATE_FILTERS = 'SUBMIT_EXPECTED_DATE_FILTERS'
}

export enum SORT {
  ASC = 'asc',
  DESC = 'desc'
}

export enum FILTER_TYPE {
  SELECT = 'select',
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  TIME = 'time'
}

export interface Option {
  id: string;
  name: string;
}

export interface TableFiltersState {
  filters: TableFilters;
  data?: Data[];
  displayedData?: Data[];
  filterAnchorElement: HTMLElement | null;
  activeColumn?: TABLE_COLUMN;
  sort?: SORT;
  sortByColumn?: TABLE_COLUMN;
  filterUpdatedCount?: number;
  sortUpdatedCount?: number
}

export interface TableFilters {
  [TABLE_COLUMN.TYPE]: {
    selectedValues?: Record<string, boolean>;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.CONTACT]: {
    searchQuery?: string;
    checkedFilteredData?: Record<string, boolean>;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.TOTAL_DUE]: {
    fromValue?: number;
    toValue?: number;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.TOTAL_OVERDUE]: {
    fromValue?: number;
    toValue?: number;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.TOTAL_INVOICED]: {
    fromValue?: number;
    toValue?: number;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.INVOICES_DUE]: {
    fromValue?: number;
    toValue?: number;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.TOTAL_DUE]: {
    fromValue?: number;
    toValue?: number;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.AVERAGE_SALE]: {
    fromValue?: number;
    toValue?: number;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.DAYS_TO_PAY]: {
    fromValue?: number;
    toValue?: number;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.DEPENDENCE]: {
    fromValue?: number;
    toValue?: number;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.LAST_ACTIVITY]: {
    fromDate?: Date;
    toDate?: Date;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.TYPE]: {
    selectedValues?: Record<string, boolean>;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.CONTACT_NAME]: {
    searchQuery?: string;
    checkedFilteredData?: Record<string, boolean>;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.CONVERTED_AMOUNT_DUE]: {
    fromValue?: number;
    toValue?: number;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.CONVERTED_AMOUNT_TOTAL]: {
    fromValue?: number;
    toValue?: number;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.DUE_DATE]: {
    fromDate?: Date;
    toDate?: Date;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.INVOICE_NUMBER]: {
    searchQuery?: string;
    checkedFilteredData?: Record<string, boolean>;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.ISSUE_DATE]: {
    fromDate?: Date;
    toDate?: Date;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.EXPECTED_DATE]: {
    fromDate?: Date;
    toDate?: Date;
    label?: string;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.PDF_NAME]: {
    searchQuery?: string;
    checkedFilteredData?: Record<string, boolean>;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.CREATED_BY]: {
    searchQuery?: string;
    checkedFilteredData?: Record<string, boolean>;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.SAVED_ON]: {
    fromDate?: Date;
    toDate?: Date;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.REPORT_NAME]: {
    searchQuery?: string;
    checkedFilteredData?: Record<string, boolean>;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.NEXT_GENERATE_AT]: {
    fromDate?: Date;
    toDate?: Date;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.PERIOD]: {
    searchQuery?: string;
    checkedFilteredData?: Record<string, boolean>;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.SENDING_TO]: {
    searchQuery?: string;
    checkedFilteredData?: Record<string, boolean>;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.TIME]: {
    fromTime?: string;
    toTime?: string;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.HELD_FOR_REVIEW]: {
    fromTime?: string;
    toTime?: string;
    filterType: FILTER_TYPE;
  };
  [TABLE_COLUMN.STATUS]: {
    selectedValues?: Record<string, boolean>;
    filterType: FILTER_TYPE;
  };
}

export interface FilterTableActionPayload {
  [FilterTableActionTypes.SET_INITIAL_DATA]: {
    data: Data[];
  };
  [FilterTableActionTypes.TOGGLE_FILTER_MENU]: {
    filterAnchorElement: HTMLElement | null;
    activeColumn?: TABLE_COLUMN;
  };
  [FilterTableActionTypes.SET_SORT]: {
    sort: SORT;
  };
  [FilterTableActionTypes.SUBMIT_FILTERS]: {
    selectedValues?: Record<string, boolean>;
    searchQuery?: string;
    fromValue?: number;
    toValue?: number;
    fromDate?: Date;
    toDate?: Date;
    fromTime?: string;
    toTime?: string;
    typeValue?: string;
    sort?: SORT;
    checkedFilteredData?: Record<string, boolean>;
    currentDataSelectOptions?: Data[];
  };
  [FilterTableActionTypes.SET_FILTERS_AND_SORT]: {
    filters: TableFilters;
    sort?: SORT;
    sortByColumn?: TABLE_COLUMN;
    isUsingLocalStorage?: boolean
  };
  [FilterTableActionTypes.CLEAR_FILTERS]: { initialFilters: TableFilters };
  [FilterTableActionTypes.CLEAR_ACTIVE_COLUMN_FILTER]: {
    initialFilters: TableFilters;
  };
  [FilterTableActionTypes.SUBMIT_EXPECTED_DATE_FILTERS]: {
    fromDate?: Date;
    toDate?: Date;
    label?: string
  };
}

export interface SubmitFilterArgs {
  fromValue?: number;
  toValue?: number;
  fromDate?: Date;
  toDate?: Date;
  fromTime?: string;
  toTime?: string;
  selectedValues?: Record<string, boolean>;
  searchQuery?: string;
  checkedFilteredData?: Record<string, boolean>;
  currentDataSelectOptions?: Data[];
}

export interface TableFiltersWithSort {
  filters: TableFilters;
  periodValue?: string;
  sort: {
    sort?: SORT;
    sortByColumn?: TABLE_COLUMN;
  };
}

export type TableFiltersData = Record<string, TableFiltersWithSort>;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type ActionMap<M extends { [index: string]: any }> = {
  [Key in keyof M]: M[Key] extends undefined
    ? {
        type: Key;
      }
    : {
        type: Key;
        payload: M[Key];
      };
};

export type FilterTableAction = ActionMap<FilterTableActionPayload>[keyof ActionMap<FilterTableActionPayload>];
